'use strict'

module.exports = require('./globalthis').TextDecoder
